import styled from '@emotion/styled';
import { mq } from '~/lib';
import { breakpointsRaw } from '~/theme/breakpoints';
import { Text } from '~/shared/components/Text/Text';
import { Grid } from '~/shared/components/Grid';

export const StyledCreateAccountLabel = styled.div(({ theme }) => ({
    fontSize: theme.fontSizes['2xs'],
    span: {
        color: theme.colors.orangeMedium,
    },
}));

export const StyledAside = styled.aside({
    [mq(0, breakpointsRaw.sm)]: {
        display: 'none',
    },
});

export const StyledGrid = styled(Grid)(() => ({
    width: '100%',
    gridAutoFlow: 'row',
    [mq(0, breakpointsRaw.md)]: {
        gridTemplateColumns: '1fr',
        rowGap: 'small',
    },
}));

export const ErrorMessage = styled(Text)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    color: theme.colors.negative,
}));

export const StyledImageWrapper = styled('div')(({ theme }) => ({
    marginTop: theme.space['3'],
    width: '100%',
}));
